import { FC, useMemo } from "react"
import { useSelector } from "react-redux"
import { Link } from "gatsby"

// component
import { ChoiceCard } from "../Marmalade/ChoiceCard/ChoiceCard"

// icon
import { DocumentIcon } from "@eventbrite/marmalade"

// utils
import { events } from "../../utils/heap/tracking_events"
import { returnUrlWithLangCodePrefixOnly } from "../../utils/general_utils"

// types
import { RootState } from "../../store/store"

// styles
import {
  featuredArticlesWrapper,
  featuredArticlesSection,
  featuredArticlesCard,
  iconWrapper,
  textWrapper,
  featuredArticlesHeader
} from "./FeaturedArticles.module.scss"
import { handleUrlString } from "../../utils/seo/seo_utils"

export type Props = {
  content:
    | Queries.HomepageDataQuery["helpCenterHomePage"]["attendee"]["content"][0]
    | Queries.HomepageDataQuery["helpCenterHomePage"]["organizer"]["content"][0]
  prefixedBasePath: string
}

const FeaturedArticles: FC<Props> = ({ content, prefixedBasePath }) => {
  const audience = useSelector((State: RootState) => State.audience)
  const articleList = useMemo(() => {
    if ("attendeeArticles" in content) {
      return content?.attendeeArticles
    } else if ("organizerArticles" in content) {
      return content?.organizerArticles
    }
  }, [content])
  if (!content || articleList?.length <= 0) {
    return null
  }
  if ("attendeeArticles" in content || "organizerArticles" in content) {
    return (
      <>
        <h2 className={featuredArticlesHeader}>{content?.title}</h2>
        <div className={featuredArticlesWrapper}>
          <div className={featuredArticlesSection}>
            {articleList?.map((art) => {
              return art?.slug ? (
                <Link
                  key={art.id}
                  to={handleUrlString(
                    `${prefixedBasePath}/articles/${art?.articleId}/${art?.slug}`,
                    { removePrefix: true }
                  )}
                >
                  <ChoiceCard
                    className={featuredArticlesCard}
                    testId={art.id}
                    wrapperButtonOnClick={() => {
                      events?.homepageFeaturedArticleClick(
                        audience,
                        art?.title,
                        ChoiceCard?.name
                      )
                    }}
                    wrapperButtonOnKeyUp={(e) => {
                      if (e.key === "Enter") {
                        events?.homepageFeaturedArticleClick(
                          audience,
                          art?.title,
                          ChoiceCard?.name
                        )
                      }
                    }}
                  >
                    <div
                      className={featuredArticlesCard}
                      style={{
                        height: "80px"
                      }}
                    >
                      <div className={iconWrapper}>
                        <DocumentIcon size="large" />
                      </div>
                      <div className={textWrapper}>{art.title}</div>
                    </div>
                  </ChoiceCard>
                </Link>
              ) : null
            })}
          </div>
        </div>
      </>
    )
  }
}

export default FeaturedArticles